import { IGetVehicleDetails } from "../../utils/types";
import { apiManager } from "../api-manager";

export const getVehicleDetails = async (params?: {
  type?: string;
  make?: string;
}) => {
  const res = await apiManager.get<IGetVehicleDetails>(
    "/vehicles/vehiclesDetails",
    params
  );
  return res;
};
